export default "__VITE_ASSET__DAZc3Xvk__"